import { useMutation, useQueryClient } from '@tanstack/react-query';

import { venueMarkNotificationsReceivedApi } from '../../../api/notifications/venueMarkNotificationsReceivedApi';

type Props = {
  venueID: string | undefined;
  onSuccess?: () => void;
};

export const useVenueMarkNotificationsReceivedMutation = ({ venueID, onSuccess }: Props) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: venueMarkNotificationsReceivedApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['venueListNotifications', venueID] });
      queryClient.invalidateQueries({ queryKey: ['venueGetUnreadNotificationCount', venueID] });
      onSuccess?.();
    },
  });
};
